import { Box, Hidden } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import PartnerBankImage from './PartnerBankImage';
import { BANKS_LOGOS, BANK_REFIN_LOGOS } from './logos';

const useStyles = makeStyles()(() => ({
  logosContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
}));

interface PartnerBanksProps {
  variant?: 'unicolored' | 'multicolored';
  data?: { name: string; linkEnabled: boolean }[];
  isRefin?: boolean;
}

const PartnerBanks = ({
  variant = 'unicolored',
  data,
  isRefin = false,
}: PartnerBanksProps) => {
  const { classes } = useStyles();
  const logos = isRefin ? [...BANK_REFIN_LOGOS] : [...BANKS_LOGOS];

  return (
    <>
      <Hidden mdUp>
        <div className={classes.logosContainer}>
          {logos.map((item) => (
            <PartnerBankImage
              {...{ item, variant }}
              key={item.key}
              isLink={data?.find(({ name }) => name === item.key)?.linkEnabled}
            />
          ))}
        </div>
      </Hidden>

      <Hidden mdDown>
        {[
          logos.slice(0, 4),
          logos.slice(4, 9),
          logos.slice(9, 14),
          logos.slice(14, 19),
        ].map((section, index) => (
          <Box
            key={index}
            mt={index === 0 ? 0 : 7}
            className={classes.logosContainer}
          >
            {section.map((item) => (
              <PartnerBankImage
                {...{ item, variant }}
                key={item.key}
                // isLink={
                //   data?.find(({ name }) => name === item.key)?.linkEnabled
                // }
              />
            ))}
          </Box>
        ))}
      </Hidden>
    </>
  );
};

export default PartnerBanks;
